import { getCategoryList } from '@/api/product'

async function getCategoryListInfo() {
    let result = await getCategoryList()
    let categoryList = [
        
    ]
    result.data.forEach((item) => {

        let obj = {
            path: `/product/productHome/${item.id}`,
            name: `homepage${item.id}`,
            component: () => import("@/views/productHome"),
            meta: {
                title: item.categoryName                ,
                show: true,
                fuName: 'product',
                id: item.id

            },
        }
        categoryList.push(obj)
    })
    return categoryList
}


let categoryList = await getCategoryListInfo()


export const routerList = [
    {
        path: "/",
        redirect: { name: 'home' },
        meta: {
            title:'首页',
            show: false,
            enTitle:'Home Page'
        }
    },
    {
        path: "/home",
        name: 'home',
        component: () => import("@/views/home"),
        meta: {
            title:'首页',
            show: true,
              enTitle:'Home Page'
        }
    },
    {
        path: "/product",
        name: 'product',
        redirect: { name: 'homepage' },
        component: () => import("@/views/product"),
        redirect: { name: 'allProduct' },
        meta: {
            title:'产品',
            show: true,
              enTitle:'Product'
        },
        children:[
           
            ...categoryList,
            {
                path: `/product/allProduct`,
                name: `allProduct`,
                component: () => import("@/views/allProduct"),
                meta: {
                   title:`${localStorage.getItem('change-language')=='zh'?'所有产品':'AllProducts'}`,
                    show: true,
                    fuName: 'product',
                    // id: item.id
                      enTitle:'all products'
                },
            },
        ]
    },
    {
        path: "/about",
        name: 'about',
        component: () => import("@/views/about"),
        meta: {
            title:'关于我们',
            show: true,
              enTitle:'About Us'
        }
    },
    {
        path: "/newsCenter",
        name: 'newsCenter',
        component: () => import("@/views/newsCenter"),
        meta: {
            title:'新闻中心',
            show: true,
              enTitle:'News Center'
        }
    },
    {
        path: "/contact",
        name: 'contact',
        component: () => import("@/views/contact"),
        meta: {
            title:'联系我们',
            show: true,
              enTitle:'Contact Us'
        }
    },
    {
        path: "/recruitmentCenter",
        name: 'recruitmentCenter',
        component: () => import("@/views/recruitmentCenter"),
        meta: {
            title:'招聘中心',
            show: true,
              enTitle:'Recruitment Center'
        }
    },

    {
        path: "/productDetails",
        name: 'productDetails',
        component: () => import("@/views/productDetails"),
        meta: {
            title:'产品详情',
            show: false,
              enTitle:'Product Details'

        },
    },
    {
        path: "/information",
        name: 'information',
        component: () => import("@/views/information"),
        meta: {
            title: '',
            show: false,
              

        },
    },
    {
        path: "/centerDetail",
        name: 'centerDetail',
        component: () => import("@/views/centerDetail"),
        meta: {
            // title:localStorage.getItem('change-language')=='zh' ?  '招聘详情':'Recruitment Details',
            title:'招聘详情',
            show: false,
              enTitle:'Recruitment Details'

        },
    },
]


